import classNames from 'classnames'
import { useState } from 'react'

import { MyMonitoringLogoOnly } from '@apps-common/components/common/logos'
import { ButtonTab } from '@apps-common/components/elements'
import { VertSpacerMd } from '@apps-common/components/layout'
import { ModalBody, ModalContainer, ModalHeader, ModalHeaderContainer } from '@apps-common/components/modals/modal'
import { commonIcons } from '@apps-common/config/icons'
import { ModalDismiss } from '@apps-common/config/modal'

export type UnitUserType = 'myMonitoring' | 'system'

export interface ISiteManageUsersModalProps {
  unitId: string
}

export const SiteManageUsersModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: ISiteManageUsersModalProps
}) => {
  const [tab, setTab] = useState<UnitUserType>('myMonitoring')

  return (
    <ModalContainer alwaysMobile innerClasses='!max-w-[700px]'>
      <ModalHeaderContainer>
        <div className='flex items-center justify-between gap-[10px]'>
          <ModalHeader subtitle='Users' subtitleClasses='capitalize' />
          <button
            type='button'
            aria-label='Close filter'
            className='bg-secondary-content/5 text-secondary-content text-[1.2em] w-[35px] h-[35px] rounded-full flex items-center justify-center'
            onClick={() => {
              onDismiss(null, ModalDismiss.Confirm)
            }}
          >
            <commonIcons.close />
          </button>
        </div>
        <VertSpacerMd />
        <div className='flex gap-[5px] sm:gap-[10px] mx-auto'>
          <ButtonTab
            classes='min-w-[50%] sm:min-w-[180px]'
            active={tab === 'myMonitoring'}
            callback={() => setTab('myMonitoring')}
            activeClasses='bg-secondary-content text-secondary'
            nonActiveClasses='bg-secondary-content/10 text-secondary-content'
          >
            <MyMonitoringLogoOnly
              color={classNames(tab === 'myMonitoring' && 'fill-secondary', tab !== 'myMonitoring' && 'fill-secondary-content')}
              classes='w-[22px]'
            />
            myMonitoring
          </ButtonTab>
          <ButtonTab
            classes='min-w-[50%] sm:min-w-[180px]'
            active={tab === 'system'}
            callback={() => setTab('system')}
            activeClasses='bg-secondary-content text-secondary'
            nonActiveClasses='bg-secondary-content/10 text-secondary-content'
          >
            <commonIcons.users />
            System
          </ButtonTab>
        </div>
      </ModalHeaderContainer>
      <ModalBody classes='!pt-[140px] !pb-[100px] sm:!pb-[70px] w-full'>
        <div />
      </ModalBody>
    </ModalContainer>
  )
}
